import { isGreeting } from '@guuru/chat-common';
import { ChatAPI } from '@guuru/chat-web';
import handleChatGreeting from '../../commands/handleChatGreeting';

export default {
  validate() {
    return true;
  },

  render() {
    const question = ChatAPI.storeRetrieveQuestion();
    const channel = ChatAPI.storeRetrieveChannel();
    if (channel === 'form') {
      return { goToNextStep: true };
    }
    if (isGreeting(question)) {
      return handleChatGreeting(question);
    }

    return { goToNextStep: true };
  },
};
